import './styles/notificationStyles.css';

import { Box, IconButton, Toolbar, Typography } from '@mui/material';
import { LuX as HighlightOffIcon } from 'react-icons/lu';
import { useSelector } from 'react-redux';

import EmptyArt from '../../../assets/empty_art.svg';
import { AppState } from '../../../infra/store';
import Show from '../show';
import NotificationItem from './components/notificationItem';
export interface INotifications {
  onClose?: () => void;
}

const Notifications = ({ onClose }: INotifications) => {
  const notifications = useSelector((state: AppState) => state.websocketReducer.notifications);

  return (
    <Box className="notifications-container">
      {/* Toolbar spacer to align with AppBar */}
      <Toolbar sx={{ minHeight: 64, display: 'flex', justifyContent: 'flex-end', px: 2, width: '100%' }}>
        <Typography
          noWrap
          component="div"
          variant="h5"
          sx={{ color: 'var(--text-color)', marginRight: 'auto', flexGrow: 1 }}
        >
          <strong>Alertas</strong>
        </Typography>
        {!!onClose && (
          <Box sx={{ flexGrow: 0 }}>
            <IconButton
              onClick={onClose}
              color="primary"
              edge="end"
              sx={{
                '&:hover': {
                  backgroundColor: 'action.hover'
                },
                marginLeft: 'auto'
              }}
            >
              <HighlightOffIcon />
            </IconButton>
          </Box>
        )}
      </Toolbar>

      <Show when={notifications.length === 0}>
        <div className="notification-art-container">
          <div>
            <img src={EmptyArt} alt="Imagen que representa que no hay contenido" />
            <Typography component="p" variant="body1">
              No hay notificaciones
            </Typography>
          </div>
        </div>
      </Show>
      <Show when={notifications.length > 0}>
        <ul className="notification-item-container">
          {notifications.map((notification, key) => (
            <li key={key}>
              <NotificationItem notification={notification} />
            </li>
          ))}
        </ul>
      </Show>
    </Box>
  );
};

export default Notifications;
